/* EmptyReviews.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _10 = "._y3gn1h6o{text-align:center}";
const _9 = "._18s8tvx8{margin:var(--ds-space-100,8px) 0 var(--ds-space-200,1pc) 0}";
const _8 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _7 = "._4t3i1lit{height:10pc}";
const _6 = "._1bsb1lit{width:10pc}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LinkButton } from '@atlaskit/button/new';
import { BodyNormal, Button, H5 } from '@atlassian/mpac-primitives';
import { HostingDisplayName } from '@atlassian/mpac-types';
import React from 'react';
import emptyReviewsImg from './empty-reviews.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._ca0qoahv{padding-top:var(--ds-space-600,3pc)}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1h6o{justify-content:center}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ca0qoahv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const Img = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1lit _4t3i1lit", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Img.displayName = 'Img';
}
const Title = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = H5,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Title.displayName = 'Title';
}
const Description = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8tvx8 _y3gn1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
export const EmptyReviews = _ref5 => {
  let {
    hosting,
    onClick,
    isLoggedIn,
    loginRef
  } = _ref5;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Img, {
      src: emptyReviewsImg,
      alt: "Empty reviews"
    }), /*#__PURE__*/_jsx(Title, {
      children: "Be the first to share your experience!"
    }), /*#__PURE__*/_jsxs(Description, {
      children: ["There are no reviews yet for the ", HostingDisplayName[hosting], " version of this app."]
    }), !isLoggedIn && loginRef ? /*#__PURE__*/_jsx(LinkButton, {
      href: loginRef,
      children: "Sign in to write a review"
    }) : /*#__PURE__*/_jsx(Button, {
      "aria-haspopup": "dialog",
      onClick: onClick,
      children: "Write a review"
    })]
  });
};